import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const ContactAPI = createApi({
    reducerPath: "ContactAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            if (!["AddContactContent", "UpdateContactContent"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({

        getContactLIst: builder.query({
            query: () => `admin/contacts/list`,
        }),
          
        AddContactContent:builder.mutation({
            query: ({formData}) => ({
                url: "admin/contact-content/store",
                method: "POST",
                body: formData,
            }),
        }),

        UpdateContactContent:builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/contact-content/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
        getContactContentById: builder.query({
            query: () => `contact-content/list`,
        }),
   
    }),
});

export const { useGetContactLIstQuery, useAddContactContentMutation, useUpdateContactContentMutation, useGetContactContentByIdQuery} = ContactAPI;
